import type { CredentialKind, CredentialStatus } from "@/types";

export function credentialKindLabel(kind: CredentialKind): string {
  switch (kind) {
    case "X509": return "Certificate (X.509)";
    case "SshKey": return "SSH key";
    case "PgpKey": return "PGP key";
    default: return kind;
  }
}

export function credentialKindIcon(kind: CredentialKind): string {
  switch (kind) {
    case "X509": return "bi bi-patch-check";
    case "SshKey": return "bi bi-terminal";
    case "PgpKey": return "bi bi-envelope-lock";
    default: return "bi bi-shield-lock";
  }
}

export function credentialBadgeLabel(status: CredentialStatus): string {
  switch (status) {
    case "Active": return "Active";
    case "PendingCsr": return "Awaiting certificate";
    case "Revoked": return "Revoked";
    default: return status;
  }
}

/** Semantic badge class per DESIGN-GUIDELINES. */
export function credentialBadgeClass(status: CredentialStatus): string {
  switch (status) {
    case "Active": return "bg-success";
    case "PendingCsr": return "bg-warning";
    case "Revoked": return "bg-secondary";
    default: return "bg-secondary";
  }
}

/** Whole days until expiry: negative = expired, null = the kind never expires (SSH). */
export function daysUntilExpiry(notAfter?: string | null): number | null {
  if (!notAfter) return null;
  return Math.floor((new Date(notAfter).getTime() - Date.now()) / 86_400_000);
}

/** Expiry text colour: danger inside 7 days (or expired), warning inside 30. */
export function expiryClass(notAfter?: string | null): string {
  const days = daysUntilExpiry(notAfter);
  if (days === null) return "";
  if (days < 7) return "text-danger";
  if (days < 30) return "text-warning";
  return "";
}

export function expiryLabel(notAfter?: string | null): string {
  const days = daysUntilExpiry(notAfter);
  if (days === null) return "—";
  const date = new Date(notAfter!).toLocaleDateString();
  if (days < 0) return `Expired ${date}`;
  if (days < 30) return `${date} (${days}d)`;
  return date;
}
